import type { Configuration } from '@carvana/microfrontend';
import { MfeReact } from '@carvana/microfrontend-react';
import { getEnvironment } from './getEnvironment';

export const getMfeConfig = (): Configuration => ({
  name: 'selfservicepayments-ui',
  Render: MfeReact(),
  ENV: getEnvironment(),
  debug: false,
  globals: {
    React: () => import('react'),
    react: () => import('react'),
    ReactDOM: () => import('react-dom'),
    reactDom: () => import('react-dom'),
    'react-dom': () => import('react-dom'),
    JSXRuntime: () => import('react/jsx-runtime'),
    styled: () => import('styled-components'),
    'styled-components': () => import('styled-components'),
    PropTypes: () => import('prop-types'),
    propTypes: () => import('prop-types'),
    'prop-types': () => import('prop-types'),
  },
  files: [],
});
